/*
 * @Author: Merlin
 * @Date: 2024-03-11 14:16:26
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-03 14:14:35
 * @Description:  这里用于“主画布” 的动画
 */

// oData 内包含内容如下：
// 包含 1：p, z,
// 包含 2：P, X, A, E, R, Q, O, H
import * as oData from './pharaoh-anim-data';

const fi = oData.Q.length;
const Fi = (n, i) => {
    return Math.floor(
        Math.random()
        * (i - n)
        + n
    );
}


// ↓ 在2个画布的绘制都有使用的类 （推断：从大图中取小图）  
export class u {
    constructor(
        t, // i （大图 dom 对象
        s, // oData.p （数组
        a, // 'bonus' （小图名
    ) {
        this.atlas = t;
        this.atlasData = s;
        this.x = 0;
        this.y = 0;
        this.setType(a);
        this.setScale(1);
    }
    // ↓入参：小图名称
    setType(t) {
        // console.log("t", t);
        this.type = t,
        this.data = this.atlasData[t];
    }
    setScale(t) {
        this.scale = t;
        // 取得宽高信息
        const [,, s, a] = this.data;
        this.scW = s * t;
        this.scH = a * t;
    }
    redraw(t) {
        // ↓ 取得：x, y, width, height
        const [s, a, i, h] = this.data;
        t.drawImage(
            this.atlas,
            s,
            a,
            i,
            h,
            this.x,
            this.y,
            this.scW,
            this.scH,
        );
    }
}


class pi {
    constructor(i) {
        this.index = i;
    }
    init(i) {
        this.x = 0;
        this.y = 0;
        this.scale = 1;
        this.img = new u(i, oData.p, "i0");
        this.img1Bluer = new u(i, oData.p, "i0");
        this.imgMask = new u(i, oData.p, "i0");
        this.imgBonus = new u(i, oData.p, "bonus");
        this.imgBonus2 = new u(i, oData.p, "bonus2");
        this.imgBonusBluer = new u(i, oData.p, "bonusBluer");
        this.imgBonus2Bluer = new u(i, oData.p, "bonus2Bluer");
        this.imgFire = new u(i, oData.p, "iFire");
        this.imgStar = new u(i, oData.p, "star");
        this.imgStar2 = new u(i, oData.p, "star2");
        this.frame = 0;
        this.blickFrame = 0;
        this.isBluer = !1;
    }
    setType(i) {
        if (this.type !== i) {
            this.img.setType(i);
            this.img1Bluer.setType(i + "Bluer");
            this.imgMask.setType(i + "Up");
            this.type = i;
            this.setPos(this.x, this.y);
        }
    }
    setImgsPos() {
        const {x: i, y: t} = this;
        let[e, s] = oData.z[this.frame];
        e += i;
        s += t;
        this.img.x = e;
        this.img.y = s;
        this.img1Bluer.x = e;
        this.img1Bluer.y = s;
        this.imgMask.x = e;
        this.imgMask.y = s;
        this.imgBonus2.x = this.x + 11.3 * this.scale;
        this.imgBonus2.y = this.y + -30.6 * this.scale;
        this.imgBonus2Bluer.x = this.x + 11.3 * this.scale;
        this.imgBonus2Bluer.y = this.y + -30.6 * this.scale;
        // ==========================================================
        let o = oData.E[this.frame].x_position * this.scale;
        let a = oData.E[this.frame].y_position * this.scale;
        o += i;
        a += t;
        this.imgBonus.x = o,
        this.imgBonus.y = a,
        this.imgBonusBluer.x = o,
        this.imgBonusBluer.y = a,
        o = oData.R[this.frame].x_position * this.scale;
        a = oData.R[this.frame].y_position * this.scale;
        o += i;
        a += t;
        this.imgStar.x = o;
        this.imgStar.y = a;
        o = oData.P[this.frame].x_position * this.scale;
        a = oData.P[this.frame].y_position * this.scale;
        o += i;
        a += t;
        this.imgStar2.x = o;
        this.imgStar2.y = a;
    }
    setScale(i) {
        this.scale = i,
        this.setImgsScale(),
        this.wd = this.img.scW,
        this.hg = this.img.scH
    }
    setPos(i, t) {
        this.x = i;
        this.y = t;
        this.setImgsPos();
    }
    setImgsScale() {
        let[,, i] = oData.z[this.frame];
        i *= this.scale;
        this.img1Bluer.setScale(i);
        this.img.setScale(i);
        this.imgMask.setScale(i);
        let t = oData.E[this.frame].scale_factor;
        t *= this.scale;
        this.imgBonus.setScale(t);
        this.imgBonus2.setScale(this.scale);
        this.imgBonusBluer.setScale(t);
        this.imgBonus2Bluer.setScale(this.scale);
        t = oData.R[this.frame].scale_factor;
        t *= this.scale;
        this.imgStar.setScale(t);
        t = oData.P[this.frame].scale_factor;
        t *= this.scale;
        this.imgStar2.setScale(t);
    }
    updateStay() {}
    redrawStay(i) {
        this.img.redraw(i);
        if (this.type === "i8") {
            this.imgBonus2.redraw(i);
            this.imgBonus.redraw(i);
        }
    }
    updateMove() {}
    redrawMove(i) {
        this.isBluer
        ? (
            this.img1Bluer.redraw(i),
            this.type === "i8" && (this.imgBonus2Bluer.redraw(i), this.imgBonusBluer.redraw(i))
        )
        : (
            this.img.redraw(i),
            this.type === "i8" && (this.imgBonus2.redraw(i), this.imgBonus.redraw(i))
        )
    }
    initWin() {
        this.blickFrame = 0;
        this.isWin = !0;
    }
    updateWin(i) {
        this.blickFrame += 1 / 15;
        this.blickFrame >= 1 && (this.blickFrame = 0);
        this.frame = i;
        this.setImgsPos();
        this.setImgsScale();
    }
    redrawWin(i, t) {
        if (this.animation = t, this.type === "i8"){
            if (t) {
                i.save();
                i.translate(this.x + this.wd / 2, this.y + this.hg / 2);
                const e = this.frame * 2;
                i.rotate(e * Math.PI / 180);
                this.imgFire.x = -this.imgFire.scW / 2;
                this.imgFire.y = -this.imgFire.scH / 2;
                this.imgFire.redraw(i);
                i.translate(0, 0);
                i.rotate(0);
                i.restore();
                this.img.redraw(i);
                this.imgBonus2.redraw(i);
                this.imgBonus.redraw(i);
                this.imgStar.redraw(i);
                this.imgStar2.redraw(i);
            } else {
                this.frame = 0;
                this.img.redraw(i);
                this.imgBonus2.redraw(i);
                this.imgBonus.redraw(i);
            }
        } else {
            if (
                t || (this.frame = 0,
                this.setImgsPos(),
                this.setImgsScale()),
                i.save(),
                this.img.redraw(i),
                t
            ) {
                const e = this.img.scW;
                const s = this.img.scH;
                i.globalCompositeOperation = "source-atop";
                const o = i.createLinearGradient(this.x, this.y, this.x + e, this.y + s);
                o.addColorStop(0, "rgba(255, 250, 227, 0)");
                o.addColorStop(this.blickFrame / 1.1, "rgba(255, 250, 227, 0)");
                o.addColorStop(this.blickFrame, "rgba(255, 250, 227, 1)");
                o.addColorStop(this.blickFrame + (1 - this.blickFrame) / 5, "rgba(255, 250, 227, 0)");
                o.addColorStop(1, "rgba(255, 250, 227, 0)");
                i.fillStyle = o;
                i.fillRect(this.x, this.y, e, s);
            }
            i.restore()
        }
    }
    updateShadow() {}
    redrawShadow(i) {
        i.save();
        i.globalAlpha = .2;
        this.img.redraw(i);
        this.type === "i8" && (
            this.imgBonus2.redraw(i),
            this.imgBonus.redraw(i),
            this.imgStar.redraw(i),
            this.imgStar2.redraw(i)
        );
        i.restore();
    }
}



// ↓ 
class L {
    constructor(i, t, e, s) {
        this.x = i,
        this.speed = t,
        this.max = e,
        this.min = s
    }
    resize(i) {
        this.max = i;
        this.speed > 0 
        ? this.x = this.max
        : this.x = this.min
    }
    update() {
        this.x += this.speed;
        this.x > this.max 
        ? (this.x = this.max, this.speed *= -1)
        : this.x < this.min && (this.x = this.min, this.speed *= -1)
    }
}


// ↓ 绘制主体画布 🎀🎀🎀 在 Wi 中调用 
class vi {
    constructor() {}
    init(
        i, // 大图 
        t, 
    ) {
        this.canvas = t,
        this.slimRect1 = new L(0, 8, t.width, 0);
        this.slimRect2 = new L(t.width,-8, t.width, 0);
        this.slimRect3 = new L(0, 8, t.width, 0);
        this.slimRect4 = new L(t.width,-8, t.width, 0);
        this.topLeftSlims = new u(i, oData.p, "slims");
        this.topRightSlims = new u(i, oData.p, "slims");
        this.botSlims = new u(i, oData.p, "slims");
        this.imgMidSlim = new u(i, oData.p, "slimsMid");
    }
    resize(i) {
        this.topLeftSlims.x = [183.75, -381.7][i];
        this.topLeftSlims.y = [65.3, 61][i];
        this.topRightSlims.x = [1124.25, 558.8][i];
        this.topRightSlims.y = [65.3, 61][i];
        this.imgMidSlim.x = [998.9, 433.45][i];
        this.imgMidSlim.y = [10.95, 7.75][i];
        this.botSlims.x = [672, 107.3][i];
        this.botSlims.y = [1045.4, 1078.1][i];
        this.slimRect1.resize(this.canvas.width);
        this.slimRect2.resize(this.canvas.width);
        this.slimRect3.resize(this.canvas.width);
        this.slimRect4.resize(this.canvas.width);
    }
    update() {
        this.slimRect1.update();
        this.slimRect2.update();
        this.slimRect3.update();
        this.slimRect4.update();
    }
    redraw(i) {
        // ↓ 主体画布在此绘制 
        this.topLeftSlims.redraw(i);
        this.topRightSlims.redraw(i);
        this.imgMidSlim.redraw(i);
        this.botSlims.redraw(i);
        i.save();
        i.globalCompositeOperation = "source-atop";
        const arr01 = [this.slimRect1, this.slimRect2, this.slimRect3, this.slimRect4];
        arr01.forEach(({x: t}, e)=>{
            let s = 11.55;
            const [o, a] = [350, 89];
            (e === 1 || e === 3) && (t = t - o);
            e > 1 && (s = this.canvas.height * .9);
            const r = i.createLinearGradient(t, s, t + o, s + a);
            const h = "255, 180, 13";
            r.addColorStop(0, `rgba(${h}, 0)`);
            r.addColorStop(.5, `rgba(${h}, ${.8}`);
            r.addColorStop(1, `rgba(${h}, 0)`);
            i.fillStyle = r;
            i.fillRect(t, s, o, a);
        });
        i.restore();
    }
}

// ↓ 推测：是特奖摇中之后的放射效果动画 
class Ci { 
    constructor(
        i, // 大图
        t, // 推测是 canvas dom
    ) {
        this.canvas = t,
        this.live = !1,
        this.parts = [];
        for (let e = 0; e < 80; e++) {
            const s = new u(i, oData.p, "coin");
            s.init = ()=>{
                const o = Math.random() * 6;
                const a = 20;
                s.alpha = 1,
                s.angle = o,
                s.dx = Math.cos(o) * a,
                s.dy = Math.sin(o) * a,
                s.scale = Math.random() * (1.2 - .7) + .7,
                s.cX = t.width / 2,
                s.cY = t.height / 2,
                s.delay = Math.floor(Math.random() * 30)
            };
            this.parts[e] = s
        }
    }
    init() {
        this.live = !0;
        this.frame = 0;
        this.parts.forEach(i=>i.init())
    }
    update() {
        if (!this.live) return;
        this.parts.forEach(i=>{
            i.delay <= 0 && (
                i.cX += i.dx,
                i.cY += i.dy,
                i.scale -= .025,
                i.scale <= 0 && (i.delay = 1e3)
            );
            i.delay--;
        })
    }
    redraw(i) {
        if (!this.live) return;
        this.parts.forEach(t=>{
            const canDO = t.delay <= 0;
            if (!canDO) return;
            i.save();
            i.translate(t.cX, t.cY);
            i.rotate(t.angle);
            i.scale(t.scale, t.scale);
            t.redraw(i);
            i.restore();
        });
    }
}


// ↓ 这几项声明用于 class mi 中 
let S = null;
let I = null;
const ii = 40;
const j = ii / 2;

class mi {
    constructor(i) {
        console.log("柱子：", i);
        this.index = i;
        this.cells = [];
        for (let t = 0; t < 4; t++) {
            this.cells.push(new pi(t));
        }
        this.cells.forEach((t, e)=>{
            e < 3 && (t.nextCell = this.cells[e + 1])
        });
        this.cells[3].nextCell = this.cells[0]
    }
    init(i) {
        this.cells.forEach(t=>t.init(i))
    }
    showLineData(i) {
        this.cells.forEach(t=>{
            t.setType("i" + i[t.index])
        });
    }
    setPos(i, t) {
        this.x = i;
        this.y = t;
    }
    resize(i) {
        const t = [595, 150][i];
        const e = [150, 194][i];
        const s = [280, 218][i];
        const o = [28, 26][i];
        this.setPos(t + s * this.index + o * this.index, e);
        const a = [240, 218][i];
        const r = [8, 12][i];
        S = a + r;
        const h = [1, .77857142857][i];
        this.scale = h;
        this.cells.forEach((l, f) => {
            l.setScale(h, !0);
            l.setPos(this.x, this.y + S * f);
        });
        I = this.cells[3].y;
    }
    updateStay() {
        this.cells.forEach(i=>i.updateStay())
    }
    redrawStay(i) {
        for (let t = 0; t < 3; t++) {
            this.cells[t].redrawStay(i)
        }
    }
    initMove({counter: i, endResult: t, onEndMove: e, isFast: s}) {
        s ? (
            this.speed = S / 1.75,
            this.backSpeed = this.speed / 1.4
        )
        : (
            this.speed = S / 2.4,
            this.backSpeed = this.speed / 2
        ),
        this.counter = i,
        this.endResult = t[this.index],
        this.onEndMove = e,
        this.cells.forEach(o=>o.isBluer = !0),
        this.isStop = !1;
    }
    startMoveUp() {
        this.cells.forEach((i, t)=>{
            i.isBluer = !1;
            t === 3 
            ? i.upY = i.nextCell.upY - S
            : i.upY = this.y + S * t
        })
    }
    updateMove(i) {
        this.cells.forEach(t=>t.setPos(t.x, t.y + this.speed));
        this.counter > 0
        ? this.cells.forEach((t, e)=>{
            if (t.y > I) {
                if (e === 3){
                    this.counter--;
                    if (this.counter === 0){
                        i == null || i.scroll_set1?.stop(); // 改为 ?.stop()
                        i == null || i.scroll_set1?.toPlay();
                        this.startMoveUp()
                    }
                }
                t.setPos(t.x, t.nextCell.y - S);
                const val4if = this.counter === 1 && e < 3;
                if (val4if) {
                    const s = this.endResult.pop();
                    t.setType(`i${s}`)
                } else {
                    t.setType(`i${Math.floor(Math.random() * 9)}`);
                }
                // -----------------------------------------
                t.setPos(t.x, t.nextCell.y - S);
            }
        })
        : (
            this.speed -= this.backSpeed,
            this.backSpeed *= .8,
            this.cells[0].y < this.cells[0].upY && (
                this.index === 2 && this.onEndMove(),
                this.isStop = !0,
                this.speed = 0,
                this.cells.forEach(t=>{
                    t.setPos(t.x, t.upY)
                })
            )
        )
    }
    redrawMove(i) {
        // ↓ 点击旋转时会触发
        const t = this.cells[2].img.scW + ii;
        const e = this.cells[2].img.scH + 20;
        if (this.isStop){
            for (let s = 0; s < 3; s++){
                this.cells[s].redrawMove(i);
            }
        } else {
            this.cells.forEach(s=>s.redrawMove(i));
            i.clearRect(this.x - j, this.y - e, t, e);
        }
        i.clearRect(this.x - j, I, t, e)
    }
    updateWin() {
        for (let i = 0; i < 3; i++) {
            this.cells[i].updateWin()
        }
    }
    redrawWin(i) {
        for (let t = 0; t < 3; t++)
            this.cells[t].redrawWin(i)
    }
    updateShadow() {
        for (let i = 0; i < 3; i++)
            this.cells[i].updateShadow()
    }
    redrawShadow(i) {
        for (let t = 0; t < 3; t++)
            this.cells[t].redrawShadow(i)
    }
}


const Si = Math.PI * 2;
let xi = class {
    constructor() {}
    init(i, t) {
        const e = (o, a)=>Math.random() * (a - o) + o;
        this.x = i + e(0, 500),
        this.y = t + e(20, 200),
        this.radius = e(3, 7),
        this.scale = e(.7, 1.1),
        this.speedX = e(-5, 5),
        this.speedY = e(-5, 5);
        const s = Math.floor(-20, 20);
        this.color = `rgb(${230 + s},${230 + s},${190 + s})`
    }
    update() {
        this.x += this.speedX * this.scale,
        this.y += this.speedY * this.scale,
        this.scale > 0 ? this.scale -= .02 : this.scale = 0
    }
    redraw(i) {
        this.scale > 0 && (i.fillStyle = this.color,
        i.beginPath(),
        i.arc(this.x, this.y, this.radius * this.scale, 0, Si),
        i.fill())
    }
} ;


const V = [{x: 595, y: 243.5}, { x: 154, y: 267}];
const J = [{x: 595, y: 497}, { x: 154, y: 492}];
const Z = [{x: 595, y: 743.5}, { x: 154, y: 739}];
const W = [{x: 623, y: 149}, { x: 157, y: 194}];
const k = [{x: 623, y: 849}, { x: 157, y: 815}];

// ↓ 推断： 功能用于画线，因为调用了图： line, line2
class bi {
    constructor() {}
    init(i) {
        this.linetop = new u(i, oData.p, "line");
        this.linemid = new u(i, oData.p, "line");
        this.linebot = new u(i, oData.p, "line");
        this.lineDtop = new u(i, oData.p, "line2");
        this.lineDbot = new u(i, oData.p, "line2");
    }
    // 入参示例：['bot']
    show(i) {
        this.linesWin = i;
    }
    resize(i) {
        if (i == -1) i = 0; // 后补操作 
        this.sizeIndex = i;
        this.mobileSizeIndex = this.sizeIndex ? .75 : 1;
        this.bonusScaleD = this.sizeIndex ? 1.17 : 1;
        this.lineTopX = V[i].x;
        this.lineTopY = V[i].y;
        this.lineMidX = J[i].x;
        this.lineMidY = J[i].y;
        this.lineBotX = Z[i].x;
        this.lineBotY = Z[i].y;
        this.lineDtopX = W[i].x;
        this.lineDtopY = W[i].y;
        this.lineDbotX = k[i].x;
        this.lineDbotY = k[i].y;
    }
    update(i) {
        const {x_position: t, y_position: e} = oData.H[i];
        let {scale_factor: s} = oData.H[i];
        s *= this.mobileSizeIndex;
        // == ↓ 上 =========================================
        this.linetop.x = this.lineTopX + t;
        this.linetop.y = this.lineTopY + e;
        this.linetop.setScale(s);
        // == ↓ 中 =========================================
        this.linemid.x = this.lineMidX + t;
        this.linemid.y = this.lineMidY + e;
        this.linemid.setScale(s);
        // == ↓ 下 =========================================
        this.linebot.x = this.lineBotX + t;
        this.linebot.y = this.lineBotY + e;
        this.linebot.setScale(s);
        // == ↓ XXX =========================================
        this.diagonalScale = this.scale_factor * this.bonusScaleD;
        this.x_position = t;
        this.y_position = e;
        this.scale_factor = s;
        this.lineDtopX = W[this.sizeIndex].x;
        this.lineDtopY = W[this.sizeIndex].y;
        this.lineDbotX = k[this.sizeIndex].x;
        this.lineDbotY = k[this.sizeIndex].y;
    }
    // 入参推断： i 是 CanvasRenderingContext2D (canvas.context
    redraw(i) {
        // console.log("画线判断00：");
        const condition01 = (
            i.save(),
            i.globalCompositeOperation = "destination-over",
            this.linesWin.includes("top") && this.linetop.redraw(i),
            this.linesWin.includes("mid") && this.linemid.redraw(i),
            this.linesWin.includes("bot") && this.linebot.redraw(i),
            this.linesWin.includes("Dtop")
        );
        // 推断：↓ 通过判断则画斜线：↘ 
        if (condition01) {
            i.translate(this.lineDtopX, this.lineDtopY);
            const t = this.sizeIndex ? 42 : 39;
            i.rotate(t * Math.PI / 180);
            this.lineDtop.x = this.x_position;
            this.lineDtop.y = this.y_position;
            this.lineDtop.setScale(this.scale_factor * this.bonusScaleD);
            this.lineDtop.redraw(i);
        }
        // 推断：↓ 画斜线 ↗
        if (this.linesWin.includes("Dbot")) {
            i.setTransform(1, 0, 0, 1, 0, 0),
            i.translate(this.lineDbotX, this.lineDbotY);
            const t = this.sizeIndex ? -42 : -39;
            i.rotate(t * Math.PI / 180),
            this.lineDbot.x = this.x_position,
            this.lineDbot.y = this.y_position,
            this.lineDbot.setScale(this.scale_factor * this.bonusScaleD),
            this.lineDbot.redraw(i)
        }
        i.restore();
    }
}



const _i = [750, 202];
const yi = { top: 124, mid: 373, bot: 616 };
const gi = { top: 140, mid: 363, bot: 593 };

// ↓用于赢之后闪烁动画 
class wi {
    constructor() {}
    init(i) {
        this.imgBg = new u(i, oData.p, "lava");
    }
    show(i, t, e, s, o, a) {
        this.inFiat = s;
        this.fiatCurrency = o;
        this.locale = a;
        // console.log("🟡 this.locale = a; a =", a);
        // console.log("🟡 this.fiatCurrency = o; o =", o);
        this.partAmount = i / 20;
        this.currAmount = 0;
        this.winAmount = i;
        this.text = "0";
        this.lineDirKey = t;
        (t === "Dtop" || t === "Dbot") && (this.lineDirKey = "mid");
        this.resize(this.sizeIndex);
        this.imgCurrency = e;
    }
    resize(i) {
        if (i == -1) i = 0; // 后补操作 
        this.sizeIndex = i;
        this.orX = _i[i];
        this.orY = [yi, gi][i][this.lineDirKey];
    }
    update(i) {
        const [t, e, s] = oData.Q[i];
        this.imgBg.x = this.orX + t;
        this.imgBg.y = this.orY + e;
        this.imgBg.setScale(s);
        this.currAmount += this.partAmount;
        this.currAmount >= this.winAmount && (this.currAmount = this.winAmount);
        const o = this.currAmount.toFixed(10);
        this.text = o.substring(0, 10);
    }
    redraw(i) {
        const {x: t, y: e, scW: s, scH: o, scale: a} = this.imgBg;
        this.imgBg.redraw(i),
        i.fillStyle = "#FFF",
        i.textAlign = "center",
        i.font = `600 ${45 * a}px Montserrat Variable`;
        // console.log("this.text:", this.text); 
        const locale = this.locale || "en-US"; // 之前的替补值是 "en" 此值不是合法参数 
        // ↓ 变量头部放加号号字符为数值，原始字符形态示例： 40.00000
        const r = (+this.text).toLocaleString(locale, {
            // ↓ 此值是 USD or CNY 将影响数字左侧的货币符号 
            // currency: 'USD', // this.fiatCurrency,
            // style: "currency",
            maximumFractionDigits: 4,
            minimumFractionDigits: 2,
        });
        // console.log("显示金额 r =", r); 
        i.fillText(
            this.inFiat
            ? r
            : this.text, t + s / 2, e + o / 1.7 
        );
        if (!this.imgCurrency) return;
        i.drawImage(
            this.imgCurrency,
            this.imgBg.x + 130 * a,
            this.imgBg.y + 70 * a,
            this.imgCurrency.width * 2 * a,
            this.imgCurrency.height * 2 * a,
        );
    }
}


// 如下，创建 this.winManajer 用于处理中奖后的动效  
// this.winManajer = new di(this.lines); 
class di {
    // ↓ 参数 i 是数组 
    constructor(i) {
        this.midCount = new wi;
        this.lavaLines = new bi;
        this.lines = i;
        this.LineCells = {
            top: [i[0].cells[0], i[1].cells[0], i[2].cells[0]],
            mid: [i[0].cells[1], i[1].cells[1], i[2].cells[1]],
            bot: [i[0].cells[2], i[1].cells[2], i[2].cells[2]],
            Dtop: [i[0].cells[0], i[1].cells[1], i[2].cells[2]],
            Dbot: [i[0].cells[2], i[1].cells[1], i[2].cells[0]],
        };
        this.parts = [];
    }
    init(i) {
        this.midCount.init(i),
        this.lavaLines.init(i)
    }
    resize(i) {
        this.midCount.resize(i),
        this.lavaLines.resize(i)
    }
    start({winResult: i, onEndShowWin: t, icon: e, inFiat: s, fiatCurrency: o, locale: a}) {
        console.log("已经触发： this.winManajer.start()", );
        this.inFiat = s;
        this.fiatCurrency = o;
        this.locale = a;
        this.onEndShowWin = t;
        this.winResult = i;
        this.currIndexShow = 0;
        this.showData(0);
        this.totalShow = 0;
        this.icon = e;
        this.parts.forEach(r=>{
            r.scale = 0;
        });
    }
    // 入参是 this.currIndexShow，可能是 0
    showData(i) {
        var o, a;
        this.frame = 0;
        this.setCell(r => r.isWin = !1);
        const [t, e, s] = this.winResult[i];
        this.midCountPos = t;
        if (t === "bonus"){
            this.setCell(r=>{
                r.type === "i8" && r.initWin()
            });
        } else {
            (o = this.sounds) == null || o.line_sound2.stop();
            (a = this.sounds) == null || a.line_sound2.toPlay();
            s.forEach(r=>{
                if (r === "bonus"){
                    this.setCell(h=>{
                        h.type === "i8" && h.initWin()
                    });
                }else{
                    this.LineCells[r].forEach(h => h.initWin());
                }
            });
            this.midCount.show(
                e,
                t,
                this.icon,
                this.inFiat,
                this.fiatCurrency,
                this.locale,
            );
            for (let r = 0; r < 20; r++) {
                this.getPart().init(
                    this.midCount.orX,
                    this.midCount.orY,
                );
            }
        }
        // s = ['bot']
        this.lavaLines.show(s);
    }
    getPart() {
        let i = this.parts.find(t=>t.scale <= 0);
        return i = new xi,
        this.parts.push(i),
        i
    }
    setCell(i) {
        this.lines.forEach(t=>{
            for (let e = 0; e < 3; e++) {
                i(t.cells[e])
            }
        })
    }
    update(i) {
        this.animation = i;
        this.setCell(t => t.isWin && t.updateWin(this.frame));
        this.parts.forEach(t=>t.update());
        this.midCountPos !== "bonus" && (
            this.midCount.update(i ? this.frame : 13),
            this.lavaLines.update(i ? this.frame : 13)
        );
        // ------------------------------
        if (++this.frame >= fi){
            this.currIndexShow++;
            if (this.currIndexShow >= this.winResult.length){
                this.onEndShowWin();
                this.currIndexShow = 0;
                this.totalShow++;
            }
            // this.currIndexShow ||= 1; // 后补，防止出现0值 
            // console.log("this.showData(this.currIndexShow)", this.currIndexShow);
            this.showData(this.currIndexShow);
            this.frame = 0;
        }
    }
    redraw(i, t) {
        if (
            t && this.parts.forEach(e=>e.redraw(i)),
            this.setCell(e=>{
                const s = e.isWin ? "Win" : "Shadow";
                e[`redraw${s}`](i, t)
            }),
            this.midCountPos !== "bonus"
        ) {
            if (!t && this.totalShow >= 1) {
                this.setCell(e => {
                    e["redrawWin"](i, t);
                });
                return;
            }
            this.midCount.redraw(i);
            this.lavaLines.redraw(i);
        }
    }
}



// ===  ↓ 推断是：两侧火球向上飘起的火星  =====================================
class Bi {
    constructor(i) {
        this.parent = i;
    }
    restart() {
        const i = (e, s) => Math.random() * (s - e) + e;
        this.x = this.parent.x + i(-80, 80);
        this.y = this.parent.y + i(-80, 80);
        this.radius = i(3, 7);
        this.scale = i(.7, 1.1);
        this.speed = i(-10, -5);
        const t = Math.floor(-20, 20);
        this.color = `rgb(${230 + t},${230 + t},${190 + t})`;
    }
    update() {
        this.y += this.speed * this.scale;
        this.scale -= .01;
        this.scale <= 0 && this.restart();
    }
    redraw(i) {
        i.fillStyle = this.color; // ← 身上飘飞的火星的颜色 
        // console.log("i.fillStyle = this.color;", this.color);
        i.beginPath();
        i.arc(this.x, this.y, this.radius * this.scale, 0, $);
        i.fill();
    }
}


const $ = Math.PI * 2;
class q {
    constructor(i, t=!0) {
        this.x = 0,
        this.y = 0,
        this.fireImg = new u(i, oData.p, "fireBall"),
        this.isLeft = t,
        this.frameFireBall = 0,
        this.frameFireBallMax = oData.X.length,
        this.alphaFrame = 0,
        this.maxAlphaFrame = oData.A.length,
        this.parts = [];
        for (let e = 0; e < 25; e++){
            this.parts.push(new Bi(this))
        }
    }
    resize(i) {
        if (this.isLeft){
            this.x = [290.9, 65.15][i];
            this.y = [829.2, 868][i]
        }else{
            this.x = [1801.15, 949.3][i];
            this.y = [829.2, 868][i]
        }
        this.parts.forEach(t=>{
            t.restart();
            t.scale = Math.random();
        });
        this.fireImg.x = this.x - this.fireImg.scW / 2;
    }
    update() {
        this.frameFireBall++;
        this.frameFireBall >= this.frameFireBallMax && (this.frameFireBall = 0);
        this.alphaFrame++;
        this.alphaFrame >= this.maxAlphaFrame && (this.alphaFrame = 0);
        this.frameFireBall++;
        this.frameFireBall >= this.frameFireBallMax && (this.frameFireBall = 0);
        this.fireImg.y = this.y + oData.X[this.frameFireBall];
        this.parts.forEach(i => i.update());
    }
    redraw(i) {
        const t = "250, 59, 14";
        const e = this.x;
        const s = this.fireImg.y + this.fireImg.scH / 2;
        const o = 250;
        let a = i.createRadialGradient(e, s, 1, e, s, o);
        a.addColorStop(0, `rgba(${t}, ${oData.A[this.alphaFrame]})`);
        a.addColorStop(1, `rgba(${t}, 0`);
        i.fillStyle = a;
        i.beginPath();
        i.arc(e, s, o, 0, $);
        i.fill();
        this.fireImg.redraw(i);
        a = i.createRadialGradient(e, s, 1, e, s, o / 2);
        a.addColorStop(0, `rgba(${t}, ${oData.A[this.alphaFrame]})`);
        a.addColorStop(1, `rgba(${t}, 0`);
        i.fillStyle = a;
        i.beginPath();
        i.arc(e, s, o / 2, 0, $);
        i.fill();
        this.parts.forEach(r => r.redraw(i));
    }
}




// = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 
// ====== ↓ 最后一项 = = = = = = = = = = = = = = = = = = = = = = 
// = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 
// ↓ 顶级类，内部使用到了 vi 类 🎀🎀🎀 

export class Wi {
    constructor() {
        this.lines = [];
        for (let i = 0; i < 3; i++){
            this.lines[i] = new mi(i);
        }
        this.winManajer = new di(this.lines);
        this.borderWords = new vi;
    }
    init([
        i, // o 画布 canvas dom 
        t, // s 大图
        e, // i 数值，canvasSizeIndex 
        s, // o 声音信息
        o, // fn，设定主画布的缩放程度
    ]) {
        this.coinsExpl = new Ci(t, i);
        this.fireLeft = new q(t);
        this.fireRight = new q(t, !1);
        this.live = !0;
        const a = i.getContext("2d");
        Object.assign(this, {
            canvas: i,
            atlas: t,
            sizeIndex: e,
            sounds: s,
            ctx: a,
            setWraperScale: o, // 控制缩放 
        });
        this.lines.forEach(r=>r.init(t));
        this.winManajer.init(t);
        this.winManajer.sounds = s;
        this.randomStart();
        this.borderWords.init(t, i);
        this.imgLight = new u(t, oData.p, "light");
        this.resize(e);
    }
    isShowLight() {
        const i = this.lines[1].isStop && !this.lines[2].isStop;
        const result = this.scaleShow && i;
        // console.log("isShowLight", result);
        return result;
    }
    // ↓ 公共方法 
    randomStart() {
        this.onEndMove && (
            this.onEndMove(),
            this.setWraperScale(1)
        );
        this.setGameMode("Stay", "randomStage");
    }
    // ↓ 公共方法 
    stopAnimation() {
        for (; this.mode === "Move" && !this.lines[2].isStop; ) {
            this[`update${this.mode}`]()
        }
    }
    // ↓ 公共方法 
    skipWinAnimation() {
        for (; this.mode === "Win" && this.winManajer.totalShow === 0; ) {
            this[`update${this.mode}`]()
        }
    }
    // ↓ 这是 public 方法 
    setGameMode(i, t) {
        // console.log(`setGameMode(${i}, ${t})`); // = setGameMode(Move, [object Object])
        // 1参接收值统计： win, BonusGame （跳过不处理） 
        // 1参接收值统计： Stay, Move（在下方处理）
        // 2参接收值统计： randomStage
        this.mode = i;
        switch (i) {
            case "Stay":
                (this.lines || []).forEach(h=>{
                    h.cells.forEach(l=>{
                        const f = (
                            t === "randomStage"
                            ? Fi(0, 8)
                            : t[h.index][l.index]
                        );
                        l.setType("i" + f);
                    });
                    h.resize(this.sizeIndex)
                });
                break;
            case "Move":
                const {endResult: e, isFast: s, onEndMove: o, scaleShow: a} = t;
                const r = s ? 2 : 3;
                (this.lines || []).forEach((h, l)=>{
                    const f = a && l == 2 ? 5 : l;
                    h.initMove({
                        endResult: e,
                        onEndMove: o,
                        counter: f + r,
                        isFast: s
                    });
                });
                break
        }
    }
    // ↓ 公共方法，在屏幕变化时调用 
    resize(i) {
        // 参数是 0、1 主要处理大屏幕和小屏幕的变化 
        this.sizeIndex = i;
        if (!this.live) return;
        this.lines.forEach(t=>{
            t.resize(i);
        });
        this.winManajer.resize(i);
        this.fireLeft.resize(i);
        this.fireRight.resize(i);
        this.borderWords.resize(i);
        this.imgLight.x = [1169, 604][i];
        this.imgLight.y = [110, 152][i];
        this.imgLight.scH = [818, 771][i];
        this.imgLight.scW = [364, 278][i];
        this.fireLeft.update();
        this.fireRight.update();
        this.borderWords.update();
    }
    update() {
        const sFnName = `update${this.mode}`;
        // console.log("Get fn name =>", sFnName);
        this[sFnName]();
        if (!this.animation) return;
        this.fireLeft.update();
        this.fireRight.update();
        this.borderWords.update();
    }
    redraw() {
        this.ctx.clearRect(
            0,
            0,
            this.canvas.width,
            this.canvas.height,
        );
        this[`redraw${this.mode}`](this.ctx);
        this.fireLeft.redraw(this.ctx);
        this.fireRight.redraw(this.ctx);
        this.borderWords.redraw(this.ctx)
    }
    updateStay() {
        this.lines.forEach(i=>i.updateStay()); 
    }
    redrawStay(i) {
        this.lines.forEach(t=>t.redrawStay(i)); 
    }
    // ↓ 摇滚到目标位置 
    moveTo({endResult: i, onEndMove: t, isFast: e}) {
        this.scaleShow = i[0].includes(8) && i[1].includes(8) && !e;
        this.setGameMode("Move", {
            endResult: i,
            isFast: e,
            onEndMove: t,
            scaleShow: this.scaleShow
        });
        this.onEndMove = t;
        if (this.scaleShow){
            this.sounds.scroll2.stop();
            this.sounds.scroll2.toPlay()
        }else{
            this.sounds.scroll.stop();
            this.sounds.scroll.toPlay()
        }
    }
    updateMove() {
        this.lines.forEach(i=>i.updateMove(this.sounds))
    }
    redrawMove(i) {
        this.lines.forEach(t => t.redrawMove(i));
        if (this.isShowLight()){
            this.setWraperScale(1.1); //放大 
            this.imgLight.redraw(i);
        }else{
            this.setWraperScale(1); 
            this.wrapperScale = 1;
        }
    }
    // ↓ 公共方法，中奖后抖动效果，普通中奖，+ bonus 中奖 
    startShowWin(oParams) {
        const {
            img: i,
            winResult: t,
            onEndShowWin: e,
            isFast: s,
            inFiat: o,
            fiatCurrency: a,
        } = oParams;
        var r, h;
        this.setGameMode("Win");
        this.copy = i;
        (r = this.sounds) == null || r.line_sound1.stop();
        (h = this.sounds) == null || h.line_sound1.toPlay();
        this.winManajer.start({
            winResult: t,
            onEndShowWin: e,
            isFast: s,
            icon: this.copy,
            inFiat: o,
            fiatCurrency: a
        });
        this.animation;
    }
    updateWin() {
        this.winManajer.update(this.animation)
    }
    redrawWin(i) {
        this.winManajer.redraw(i, this.animation)
    }
    updateBonusGame() {
        this.coinsExpl.update()
    }
    redrawBonusGame(i) {
        this.animation && this.coinsExpl.redraw(i)
    }
}

